import { FC, useEffect } from "react"
import { useTranslation } from "react-i18next"

import { useAppDispatch } from "../../../core/app/hooks"
import {
  getCustomPackagePrice
} from "../../../core/app/slices/order/orderThunkApi"
import { UText } from "../../../ui-component"
import { Box, Container } from "../../../ui-component/mui.components"
import { AddNewPackaging } from "../CustomPackaging/AddNewPackaging"

import { MyCustomPackaging } from "./MyCustomPackaging"

export const CustomPackagingModule: FC = () => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getCustomPackagePrice())
  }, [])

  return (
    <Container
      component="main"
      maxWidth={"lg"}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "0 !important",
      }}
    >
      <Box component={"div"} display={"flex"} justifyContent={"start"}>
        <UText variant={"h4"} sxProp={{ pt: 6, pb: 5 }}>
          {t("customPackaging.title")}
        </UText>
      </Box>
      <Box component={"div"}>{<AddNewPackaging />}</Box>
      <Box mt={4}>{<MyCustomPackaging />}</Box>
    </Container>
  )
}
